module.exports = __webpack_public_path__ + "themes/mf/font/proximasoft-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/proximasoft-regular-webfont.woff
// module id = 145
// module chunks = 3